angular
    .module('app')
    .directive('smsArea', function ($timeout, $filter) {
        return {
            restrict: 'E',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var updateTimeout;

                scope.$watch(function () {
                    return ngModel.$modelValue;
                }, function (newValue) {
                    if (updateTimeout)
                        $timeout.cancel(updateTimeout);

                    var smsType,
                        smsLength = 0,
                        smsCount = -1,
                        charsLeft = 0,
                        text = newValue,
                        isUnicode = false;

                    var s = {
                        cut: true,
                        maxSmsNum: 9999,
                        interval: 300,

                        lengths: {
                            ascii: [160, 306, 459],
                            unicode: [70, 134, 201]
                        }
                    }

                    for (var i = 0; i < 67; i++)
                        s.lengths.ascii.push(s.lengths.ascii[s.lengths.ascii.length - 1] + 146)

                    for (var i = 0; i < 154; i++)
                        s.lengths.unicode.push(s.lengths.unicode[s.lengths.unicode.length - 1] + 64)

                    updateTimeout = $timeout(function () {
                        if (text) {
                            for (var charPos = 0; charPos < text.length; charPos++) {
                                switch (text[charPos]) {
                                    case "\n":
                                    case "[":
                                    case "]":
                                    case "\\":
                                    case "^":
                                    case "{":
                                    case "}":
                                    case "|":
                                    case "€":
                                        smsLength += 2;
                                        break;

                                    default:
                                        smsLength += 1;
                                }

                                if (text.charCodeAt(charPos) > 127 && text[charPos] != "€")
                                    isUnicode = true;
                            }

                            if (isUnicode)
                                smsType = s.lengths.unicode;
                            else
                                smsType = s.lengths.ascii;

                            for (var sCount = 0; sCount < s.maxSmsNum; sCount++) {

                                cutStrLength = smsType[sCount];
                                if (smsLength <= smsType[sCount]) {
                                    smsCount = sCount + 1;
                                    charsLeft = smsType[sCount] - smsLength;
                                    break
                                }
                            }

                            smsCount === -1 && (smsCount = s.maxSmsNum, charsLeft = 0);
                        }

                        if (smsCount < 0) {
                            smsLength = 0;
                            smsCount = 0;
                        }

                        scope.smsLength = smsLength;
                        scope.smsCount = smsCount;

                    }, s.interval);
                });
            },
            template: '<div id="sms-counters" class="sms-counters">' +
                '<span translate>TEXT_HINT_CHARACTERS_LEFT</span>:' +
                '<span class="bold">' +
                ' {{smsLength}} ' +
                '</span>' +
                '<span translate>TEXT_HINT_MESSAGES_LEFT_1</span>' +
                '<span class="bold">' +
                ' {{smsCount}} ' +
                '</span>' +
                '<span translate>TEXT_HINT_MESSAGES_LEFT_2</span>' +
                '</div>'
        };
    })
